// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bhutan from '../_raw/flag/icon_flag_bhutan.png';

export default () => <img src={Bhutan} alt="Bhutan" />;
